<ng-template #template>
  <div>
    <ng-content></ng-content>
  </div>
</ng-template>
